import styled, { CSSObject } from 'styled-components';

interface Props {
  style?: CSSObject;
}

const LoadingWrapper = styled.div<Props>`
  position: absolute;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  width: 48px;
  height: 48px;
  margin: 0 auto 0 auto;

  > div {
    animation-timing-function: linear;
    animation: 1s infinite normal spin;
  }

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }

  ${({ style }) => style || ''}
`;

export default LoadingWrapper;
